import _test from "ramda/es/test";
export default _test(/^\d{3}\/\d{7}\/\d{2}$/);